import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionService } from './session.service';
import { environment } from '../../../environments/environment';

export const moduleIdentityInterceptor: HttpInterceptorFn = (request, next) => {
  const api = new URL(environment.URL_API || '/', window.location.origin);
  const url = new URL(request.url, window.location.origin);
  const path = api.pathname.replace(/\/$/, '');
  if (url.origin !== api.origin || (path && url.pathname !== path && !url.pathname.startsWith(path + '/'))) return next(request);
  const session = inject(SessionService);
  const token = session.token;
  const identity = sessionStorage.getItem('sgprevIdentity');
  const guardiao = encodeGuardiao(session.guardiao);
  let headers = request.headers;
  if (token) headers = headers.set('Authorization', `Bearer ${token}`);
  if (identity) headers = headers.set('X-SGPREV-Identity', identity);
  // Guardião do iframe (modelo anterior a 21/09): a API identifica o operador por ele quando o
  // legado não emite a identidade assinada. Base64url para o header aceitar acentos.
  if (guardiao) headers = headers.set('X-SGPREV-Guardiao', guardiao);
  return next(request.clone({ headers }));
};

export function encodeGuardiao(guardiao: unknown): string | null {
  if (!guardiao || typeof guardiao !== 'object') return null;
  try {
    const bytes = new TextEncoder().encode(JSON.stringify(guardiao));
    let binary = '';
    bytes.forEach(b => binary += String.fromCharCode(b));
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  } catch {
    return null;
  }
}
